import { IconProps } from './IconProps';

export const PictureIcon = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        id="vector"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.16499 1.34687e-07C6.07456 -6.25493e-06 5.20733 -1.14024e-05 4.50766 0.057154C3.79118 0.115693 3.18024 0.238142 2.62085 0.523169C1.71767 0.983361 0.983361 1.71767 0.523169 2.62085C0.238142 3.18024 0.115693 3.79118 0.057154 4.50766C-1.14024e-05 5.20733 -6.25493e-06 6.07456 1.34687e-07 7.16499V8.83501C-6.25493e-06 9.92544 -1.14024e-05 10.7927 0.057154 11.4923C0.115693 12.2088 0.238142 12.8198 0.523169 13.3792C0.983361 14.2823 1.71767 15.0166 2.62085 15.4768C3.18024 15.7619 3.79118 15.8843 4.50766 15.9428C5.20731 16 6.07451 16 7.1649 16H10.435C11.5254 16 12.3927 16 13.0923 15.9428C13.8088 15.8843 14.4198 15.7619 14.9792 15.4768C15.8823 15.0166 16.6166 14.2823 17.0768 13.3792C17.3619 12.8198 17.4843 12.2088 17.5428 11.4923C17.6 10.7927 17.6 9.92549 17.6 8.8351V7.16497C17.6 6.07458 17.6 5.20731 17.5428 4.50766C17.4843 3.79118 17.3619 3.18024 17.0768 2.62085C16.6166 1.71767 15.8823 0.983361 14.9792 0.523169C14.4198 0.238142 13.8088 0.115693 13.0923 0.057154C12.3927 -1.14024e-05 11.5254 -6.25493e-06 10.435 1.34687e-07H7.16499ZM15.9943 5.8H15.9513C14.8828 5.79999 14.2978 5.79998 13.7978 5.85138C9.25277 6.31862 5.64434 9.86129 5.07683 14.3751C5.6321 14.3996 6.31499 14.4 7.2 14.4H10.4C11.5333 14.4 12.3352 14.3994 12.962 14.3482C13.5796 14.2977 13.9565 14.2022 14.2528 14.0512C14.8549 13.7444 15.3444 13.2549 15.6512 12.6528C15.8022 12.3565 15.8977 11.9796 15.9482 11.362C15.9994 10.7352 16 9.93331 16 8.8V7.2C16 6.66494 15.9999 6.20377 15.9943 5.8ZM5.2 3.6C4.31634 3.6 3.6 4.31634 3.6 5.2C3.6 6.08366 4.31634 6.8 5.2 6.8C6.08366 6.8 6.8 6.08366 6.8 5.2C6.8 4.31634 6.08366 3.6 5.2 3.6Z"
        fill={props.fill ?? '#111111'}
      />
    </svg>
  );
};

